import { GridColDef } from "@mui/x-data-grid-pro";
import ItemStatus from "../../../../../../common/components/item_status";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { computeHoursFromMinutes } from "../../../../../../common/utils/cargaHorariaUtils";

/**
 * GenerateColumns
 */

type Props = {
  onActionEdit: (idTreinamento: number | null, openState: boolean) => void,
  onActionDelete: (idTreinamento: number | null, openState: boolean) => void,
  onActionCopy: (idTreinamento: number | null, openState: boolean) => void,
};

export const GenerateTreinamentosListaColumns = ({
  onActionEdit,
  onActionDelete,
  onActionCopy,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "A";
      case 0:
        return "I";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Ativo";
      case 0:
        return "Inativo";
      default:
        return "?";
    }
  };

  return [
    {
      field: "ativo",
      filterable: false,
      headerName: "Status",
      minWidth: 75,
      width: 75,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            title={computeItemStatusTitle(params.value ? 1 : 0)}
            color={computeItemStatusColor(params.value ? 1 : 0)}
            description={computeItemStatusDescription(params.value ? 1 : 0)} />
        </div>
      )
    },
    {
      field: "nome",
      filterable: false,
      headerName: "Nome",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "versao",
      filterable: false,
      headerName: "Versão",
      minWidth: 100,
      width: 100,
      sortable: false,
    },
    {
      field: "cargaHoraria",
      filterable: false,
      headerName: "Carga Horária",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: ({ value }) => {
        return (<div>{`${computeHoursFromMinutes(value)} hrs`}</div>);
      }
    },
    {
      field: 'acoes',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      valueGetter: (_, row) => row['idTreinamento'] as number,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEdit(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDelete(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
    {
      field: 'copiar',
      sortable: false,
      filterable: false,
      headerName: 'Copiar',
      width: 75,
      valueGetter: (_, row) => row['idTreinamento'] as number,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionCopy(params.value, true)}>
              <DynamicIcon nameIcon="ContentCopy" size={25} className="text-purple-500" />
            </IconButton>
          </div>
        );
      }
    }
  ];
}